import React from 'react';

export type SingpassButtonVariant = 'white' | 'red';

export interface SingpassLoginButtonProps {
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  loadingLabel?: string;
  /** White fill is the default per Singpass guidelines on light UIs. */
  variant?: SingpassButtonVariant;
  className?: string;
}

const publicBase = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
const logoSrc = (variant: SingpassButtonVariant) =>
  `${publicBase}/assets/singpass-logo${variant === 'red' ? '-white' : ''}.svg`;

/**
 * Standard Singpass login button per
 * https://docs.developer.singpass.gov.sg/docs/products/singpass-login/singpass-button-guidelines-for-developers-and-designers
 */
function SingpassLoginButton({
  onClick,
  disabled = false,
  loading = false,
  loadingLabel = 'Redirecting…',
  variant = 'white',
  className = '',
}: SingpassLoginButtonProps) {
  const isDisabled = disabled || loading;

  return (
    <button
      type="button"
      className={`btn-singpass btn-singpass--${variant}${className ? ` ${className}` : ''}`}
      disabled={isDisabled}
      onClick={onClick}
      aria-busy={loading}
      aria-label={loading ? loadingLabel : 'Log in with Singpass'}
    >
      {loading ? (
        <span className="btn-singpass__loading">
          <span className="btn-singpass__spinner" aria-hidden="true" />
          <span>{loadingLabel}</span>
        </span>
      ) : (
        <>
          <span className="btn-singpass__label">Log in with</span>
          <img
            src={logoSrc(variant)}
            alt=""
            aria-label="Sing pass"
            className="btn-singpass__logo"
          />
        </>
      )}
    </button>
  );
}

export default SingpassLoginButton;
